import { Component, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from '../user.service';
import { Router } from '@angular/router';
import { AboutComponent } from '../about/about.component';
import { Utils } from '../utils';
import { Config } from '../config.model';
import { ConfigService } from '../config.service';
import { LogService } from '../log.service';
import { File360Resources } from '../resources';
import { componentDestroyed, OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';



@Component({
  selector: 'file360-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent extends OnDestroyMixin implements OnInit {

  private config: Config | undefined;
  title: string = "";
  helpUrl: string = "";

  /**
  * The event that emits when hamburger menu is opened
  */
  @Output() onHamburgerOpen = new EventEmitter();

  constructor(public userService: UserService,
    public configService: ConfigService,
    private logService: LogService,
    private router: Router, private aboutDialog: MatDialog) {
    //required for componentDestroyed()
    super();
  }

  ngOnInit() {

    this.userService.componentInit$.pipe(takeUntil(componentDestroyed(this))).subscribe(component => {
      setTimeout(() => {
        this.title = component.title
      });
    });

    //
    // When help URL changes, update the help link
    //
    this.configService.helpUrl.subscribe(help => {
      this.logService.logMessage(`HeaderComponent, help page = ${help}`);

      this.helpUrl = help;
    });

    //
    // Load app config and set local object.
    //
    this.configService.loadConfig().pipe(takeUntil(componentDestroyed(this))).subscribe(
      config => {
        this.config = config as Config;
        this.configService.configuration = this.config!;
        this.logService.setUser(this.userService.currentUser);


        this.logService.logMessage(`systemOffline is '${this.config.systemOffline}'`);

        //
        // Set default system outage text when the system is offline and no alternative message is provided.
        //
        if (this.config.systemOffline && (this.config!.welcomeMessage.length == 0)) {
          this.config.welcomeMessage = File360Resources.ERR_SystemUnavailable;
        }

        //
        // Default the default system text from config file.
        // Any actual error text will replace this text.
        //
        if (this.config.welcomeMessage != null && this.config.welcomeMessage.length > 0) {
          this.logService.logMessage(`welcomeMessage is '${this.config.welcomeMessage}'`);
        }

        if (this.config.forgotPasswordMessage != null && this.config.forgotPasswordMessage.length > 0) {
          this.logService.logMessage(`forgotPasswordMessage is '${this.config.forgotPasswordMessage}'`);
        }
      },
      error => {
        this.logService.logMessage(`Error loading config : '${error.Message}'`);
        console.error(error);
      });
  }

  logOff() {
    this.userService.logOff();
    this.router.navigate(['/']);
  }

  openAboutDialog(): void {

    if (Utils.isMobile()) {
      //
      // Touch devices do not get a dialog. Navigate to the component.
      //
      this.router.navigate(['about']);
    } else {

      //
      // Open a dialog with the About component
      //

      this.aboutDialog.open(AboutComponent, {
        maxWidth: 'none', // remove any default max-width on the overlay pane so we can set our own width on the dialog
        // height = 29rem is a summation of each individual element height, per CUX 2.0
        height: '29rem',
        backdropClass: 'ot-about-dialog-backdrop',
        panelClass: 'ot-about-dialog-panel'
      });
    }
  }
}
